import { PropsWithChildren, createContext, useContext, useState } from 'react';
import { TabContextValues } from './types';
const TabContext = createContext<TabContextValues>({
  selectedIndex: 0,
  changeSelectedIndex: () => {}
});
interface Props extends PropsWithChildren {
  defaultSelectedIndex?: number;
}
export function TabProvider({
  children,
  defaultSelectedIndex = 0
}: Props) {
  const [selectedIndex, setSelectedIndex] = useState(defaultSelectedIndex);
  const changeSelectedIndex = (value: number) => {
    setSelectedIndex(value);
  };
  return <TabContext.Provider value={{
    selectedIndex,
    changeSelectedIndex
  }} data-sentry-element="unknown" data-sentry-component="TabProvider" data-sentry-source-file="tab-context.tsx">{children}</TabContext.Provider>;
}
export function useTab() {
  const context = useContext(TabContext);
  if (!context) {
    throw new Error('useTab must be used within a TabProvider');
  }
  return context;
}